import { z } from "zod/v4";

export type AllowedRevisionFlow = z.infer<typeof allowedRevisionFlowSchema>;
export const allowedRevisionFlowSchema = z.enum(["raw", "curation", "translation", "media"]);
